import { createContext, useContext } from "react";
import { QuizEditorController } from "./quizEditorController";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const QuizEditorControllerContext = createContext<QuizEditorController>(null as any);
export const useQuizEditorController = (): QuizEditorController => useContext(QuizEditorControllerContext);
